import { Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

export const AboutBrands = () => {
  return (
    <div className='tw-mt-10 xl:tw-mt-20 tw-flex tw-flex-col tw-gap-4 tw-p-4 tw-pb-16 lg:tw-pb-0 xl:tw-p-6'>
      <p className='tw-text-base tw-font-semibold tw-tracking-wider tw-text-center tw-text-neutral'>Firmy, które nam zaufały</p>
      <Swiper
        modules={[Autoplay]}
        spaceBetween={16}
        slidesPerView={2}
        loop
        autoplay={{
          delay: 3000,
          disableOnInteraction: false
        }}
        breakpoints={{
          768: {
            slidesPerView: 3,
            spaceBetween: 20
          }
        }}
        className='tw-w-full'
      >
        <SwiperSlide><div className='tw-h-32 lg:tw-h-24 xl:tw-h-32 tw-bg-white-300 tw-flex tw-items-center tw-justify-center'><img src='/assets/images/clients/1.png' className='tw-max-h-full tw-w-auto' /></div></SwiperSlide>
        <SwiperSlide><div className='tw-h-32 lg:tw-h-24 xl:tw-h-32 tw-bg-white-300 tw-flex tw-items-center tw-justify-center'><img src='/assets/images/clients/2.png' className='tw-max-h-full tw-w-auto' /></div></SwiperSlide>
        <SwiperSlide><div className='tw-h-32 lg:tw-h-24 xl:tw-h-32 tw-bg-white-300 tw-flex tw-items-center tw-justify-center'><img src='/assets/images/clients/3.png' className='tw-max-h-full tw-w-auto' /></div></SwiperSlide>
        <SwiperSlide><div className='tw-h-32 lg:tw-h-24 xl:tw-h-32 tw-bg-white-300 tw-flex tw-items-center tw-justify-center'><img src='/assets/images/clients/4.png' className='tw-max-h-full tw-w-auto' /></div></SwiperSlide>
      </Swiper>
    </div>
  )
}
